import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import Overlay from '../shared/Overlay';
import { Helmet } from 'react-helmet-async';
import UpdatePasswordForm from './UpdatePasswordForm';
import { editUserPassword, getUser } from '../../redux/actions/userActions';
import permissions from '../../permissionsList';
import AccessControl from '../../AccessControl';

export function UnconnectedUpdatePassword(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user: userObj, id } = props;
  console.log('UpdatePassword props.id:', id);
  console.log('UpdatePassword userObj:', userObj);
  const { state = {} } = location;
  const previous = state.previous || '/';

  useEffect(() => {
    if (!userObj && id) {
      props.dispatch(getUser(id));
    }
  }, [userObj, id, props]);

  const updatePasswordSubmit = (values) => {
    console.log('UpdatePassword values:', values);
    console.log('UserObj:', userObj);
    props.dispatch(editUserPassword(values, navigate, previous));
  };

  const user = userObj || {
    id: id,
    title: '',
    first_name: '',
    last_name: '',
    suffix: '',
  };

  return (
    <Overlay
      rootUrl={previous}
      canClose={true}
      data-test="update-password-overlay">
      <FormattedMessage
        id="updatePassword.browserTabInfo"
        defaultMessage="Users | Editing {userName}"
        description="Done button"
        values={{
          userName: `${user.title ? user.title : ''} ${
            user.first_name ? user.first_name : ''
          } ${user.last_name ? user.last_name : ''} ${
            user.suffix ? user.suffix : ''
          }`,
        }}>
        {(txt) => (
          <Helmet>
            <title>{txt}</title>
          </Helmet>
        )}
      </FormattedMessage>
      <div className="content-container content-container--column">
        <FormattedMessage
          id="updatePassword.editUserTitle"
          defaultMessage="Edit Password For: {userName}"
          description="The title for the page to edit a unit"
          data-test="form-header"
          values={{
            userName: `${user.title ? user.title : ''} ${
              user.first_name ? user.first_name : ''
            } ${user.last_name ? user.last_name : ''} ${
              user.suffix ? user.suffix : ''
            }`,
          }}>
          {(txt) => (
            <h1 className="no-margin text-center" data-test="form-header-text">
              {txt}
            </h1>
          )}
        </FormattedMessage>
        <hr />
        <AccessControl
          data-test="access-control"
          feature={permissions.static.users.editUser}
          userToEdit={user.id}
          permissionMessage={true}>
          <UpdatePasswordForm
            onSubmit={updatePasswordSubmit}
            previous={previous}
            data-test="update-password-form"
            user={user}
          />
        </AccessControl>
      </div>
    </Overlay>
  );
}

const mapStateToProps = (state, ownProps) => {
  const { id } = ownProps;
  const user = state.users.users[id];

  return {
    user,
    id,
  };
};

function UpdatePasswordContainer(props) {
  const { id } = useParams();
  console.log('UpdatePassword ID from params:', id); 
  return <UnconnectedUpdatePassword {...props} id={id} />;
}

export default connect(mapStateToProps)(UpdatePasswordContainer);
